import { useState, useEffect } from 'react';

import { FeaturedIcon, lottieAnimations } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography, keyframes } from '@mui/material';
import Lottie from 'lottie-react';

import { OnboardingStepContainer } from './components/OnboardingStepContainer';

const LOADING_MESSAGES = appStrings.modules.onboarding.loadingMessages;
const MESSAGE_ROTATION_INTERVAL = 3350; // 3.3 seconds per message

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const AccountCreationLoading = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, MESSAGE_ROTATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <OnboardingStepContainer>
      <Box sx={headerContainerSx}>
        <FeaturedIcon iconName="Compass01" size="xl" color="Colors/Foreground/fg-secondary" />
        <Typography key={messageIndex} variant="display-sm-semibold" sx={animatedTitleSx}>
          {LOADING_MESSAGES[messageIndex]}
        </Typography>
      </Box>
      <Box sx={loadingAnimationContainerStyle}>
        <Lottie animationData={lottieAnimations.cloudComputing} style={loadingAnimationStyle} />
      </Box>
    </OnboardingStepContainer>
  );
};

const headerContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: backrs.spacing['spacing-4xl'],
  marginBottom: backrs.spacing['spacing-4xl'],
  textAlign: 'center',
});

const animatedTitleSx: SxProps<Theme> = {
  animation: `${fadeIn} 400ms ease-out`,
};

const loadingAnimationContainerStyle: SxProps<Theme> = {
  height: '50dvh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const loadingAnimationStyle: React.CSSProperties = {
  height: '100%',
  width: '100%',
};
